import React, { useEffect, useRef, useState } from 'react';
import {BrandingScreen} from '../screens/branding/ui/screens/BrandingScreen';
export default function DesignConfiguration() {

    return (
        <div>
           <BrandingScreen></BrandingScreen>
        </div>
    );
}